import { getDocuments } from "@/services/documents";
import {
  getDays,
  getGenderIdentity,
  getMonths,
  getYears,
  getYesOrNo,
} from "@/services/utilityService";

export default {
  state: {
    protocol: {},
    documentsData: [],
    gendersData: [],
    yearsData: [],
    monthsData: [],
    daysData: [],
    yesOrNoData: [],
    isFilledData: false,
  },

  getters: {
    getProtocolData: (state) => state.protocol,
    getProtocolDocumentsData: (state) => state.documentsData,
    getProtocolGendersData: (state) => state.gendersData,
    getProtocolYearsData: (state) => state.yearsData,
    getProtocolMonthsData: (state) => state.monthsData,
    getProtocolDaysData: (state) => state.daysData,
    getProtocolYesOrNoData: (state) => state.yesOrNoData,
  },

  mutations: {
    setProtocol(state, data) {
      const isEmpty = Object.keys(data).length === 0;

      if (isEmpty) {
        state.protocol = {};
        return;
      }

      if (!state.isFilledData) {
        this.dispatch("changeProtocolDatas");
      }

      let subOccupation = {
        code: "",
        description: "",
      };

      if (data?.co_sub_occupation) {
        subOccupation = {
          code: data.co_sub_occupation,
          description: data.descricao,
        };
      } else if (data?.subOccupationCode) {
        subOccupation = {
          code: data.subOccupationCode,
          description: data.subOccupationName,
        };
      }

      const isProtocol = data.protocol;

      state.protocol = {
        id: isProtocol ? data.id : "",
        typeProtocol: data.typeProtocol,
        typeProtocolId: data?.type_protocol_id
          ? parseInt(data.type_protocol_id)
          : "",
        allOncologyProtocols: data?.allOncologyProtocols
          ? data.allOncologyProtocols
          : [],

        procedureCode: data.procedureCode,
        procedureName: data.procedureName,
        procedureVersion: data?.procedureVersion,
        procedureExamId: data?.examId,
        procedureTypeId: data?.procedureTypeId,
        procedureTypeName: data?.procedureTypeName,
        occupationCode: data?.co_ocupacao
          ? data?.co_ocupacao
          : data?.occupationCode,
        occupationName: data?.no_ocupacao
          ? data?.no_ocupacao
          : data?.occupationName,
        subOccupationCode: subOccupation.code,
        subOccupationName: subOccupation.description,

        documents: isProtocol
          ? data.documents.map((doc) => ({
              ...doc,
              required: doc.pivot.yesno_id === "1",
            }))
          : [],
        genders: isProtocol ? data.sexes.map((gender) => gender.id) : [],
        attachments: isProtocol ? data.attached_model_protocols : [],
        minAgeYear: isProtocol ? String(parseInt(data.minimum_age) - 1) : "", // alteração realizada por conta da mudança solicitada na tarefa: 36258
        minAgeMonth: isProtocol ? String(parseInt(data.minimum_month) - 1) : "", // alteração realizada por conta da mudança solicitada na tarefa: 36258
        minAgeDay: isProtocol ? String(parseInt(data.minimum_day) - 1) : "", // alteração realizada por conta da mudança solicitada na tarefa: 36258
        maxAgeYear: isProtocol ? String(parseInt(data.maximum_age) - 1) : "", // alteração realizada por conta da mudança solicitada na tarefa: 36258
        maxAgeMonth: isProtocol ? String(parseInt(data.maximum_month) - 1) : "", // alteração realizada por conta da mudança solicitada na tarefa: 36258
        maxAgeDay: isProtocol ? String(parseInt(data.maximum_day) - 1) : "", // alteração realizada por conta da mudança solicitada na tarefa: 36258
        preparation: isProtocol
          ? data?.preparation
            ? data?.preparation
            : ""
          : "",
        observation: isProtocol
          ? data?.observation
            ? data?.observation
            : ""
          : "",

        isUpdate: isProtocol,
      };
    },

    async fetchProtocolDatas(state) {
      Promise.all([
        getDocuments(),
        getYesOrNo(),
        getGenderIdentity(),
        getYears(),
        getMonths(),
        getDays(),
      ]).then((requestResponse) => {
        state.documentsData = requestResponse[0].response;
        state.yesOrNoData = requestResponse[1].response;
        state.gendersData = requestResponse[2].response;
        state.yearsData = requestResponse[3].response;
        state.monthsData = requestResponse[4].response;
        state.daysData = requestResponse[5].response;
        state.isFilledData = true;
      });
    },
  },

  actions: {
    changeProtocol(context, data) {
      context.commit("setProtocol", data);
    },

    changeProtocolDatas(context) {
      context.commit("fetchProtocolDatas");
    },
  },
};
